// client/src/navigations/appMainNav.js

import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { GlobalContext } from '../context/provider';
import BottomTabNav from '../components/bottomTabNav';

// General Routes
import Login from '../pages/general/login';
import UserGate from '../pages/general/userGate';
import CreateProfile from '../pages/general/createProfile';
import Verify2FA from '../pages/general/verify2FA';
import Profile from "../pages/general/profile";
import ContactAdmin from '../pages/general/contactAdmin';
import DeleteAccount from '../pages/general/deleteAccount'
import KnowledgeSharing from '../pages/info/knowledgeSharing';

// Course Routes
import PaymentSuccess from '../pages/courses/PaymentSuccess';
import Courses from '../pages/courses/courses';
import ShoppingCart from '../pages/courses/shoppingCarts';

// Admin routes
import AdminDashboard from '../pages/admin/adminDashboard';
import AdminCourseManagement from '../pages/admin/adminCourseManagement';
import AdminInstructorManagement from '../pages/admin/adminInstructorManagement';
import AdminStudentManagement from '../pages/admin/adminStudentManagement';
import AdminMessaging from '../pages/admin/adminMessaging';
import AdminWriteKnowledge from '../pages/admin/adminWriteKnowledge';
import AdminConfigPage from '../pages/admin/AdminConfigPage';
import AdminRefunds from '../pages/admin/adminRefunds';

// Instructor routes
import InstructorDashboard from '../pages/instructors/instructorDashboard';
import InstructorCourseManagement from '../pages/instructors/instructorCourseManagment';

// Student routes
import StudentDashboard from '../pages/students/studentDashboard';
import StudentCourseManagement from "../pages/students/studentCourseManagement";

// iot routes
// import CourseCircuits from "../pages/iot/courseCircuits";
// import CircuitBuilder from '../pages/iot/circuitBuilder';
// import Simulator from '../pages/iot/simulator';

// lab engine routes
import CourseCanvases from "../pages/labEngine/courseCanvases";
import CanvasBuilder from '../pages/labEngine/canvasBuilder';
import ArduinoSimulator from '../pages/labEngine/arduinoSimulator';
import NoteBookSimulator from '../pages/labEngine/notebookSimulator';
import NodeRedDashboard from '../pages/labEngine/nodeRedDashboard';

const AppMainNav = () => {
  const { authState: { authData, isLoggedIn }, studentState, instructorState } = useContext(GlobalContext);
  
  // Determine user role
  const isStudent = authData?.role === 'student';
  const isInstructor = authData?.role === 'instructor';
  const isAdmin = authData?.role === 'admin';

  return (
    <Routes>
      <Route path="/usergate" element={<UserGate />} />
      
      {/* ✅ Login route for unauthenticated users */}
      <Route path="/login" element={<Login />} />
      {/* Root redirect */}
      <Route path="/" element={<Navigate to={isLoggedIn ? "/usergate" : "/login"} replace />} />
      {/* Create profile */}
      <Route path="/create-profile" element={<CreateProfile />} /> 
      {/* Public route - for 2FA verification after OAuth login */}
      <Route path="/verify-2fa" element={<Verify2FA />} />
      
      {/* <Route path="/iot/course/:courseId/circuit/build" element={<CircuitBuilder/>}/>
      <Route path="/iot/course/:courseId/lab/:labId/build" element={<CircuitBuilder/>}/>
      <Route path="/iot/course/:courseId/simulator" element={<Simulator/>}/> */}

      <Route path="/labengine/course/:courseId/domain/:domainName/buildcanvas" element={<CanvasBuilder/>}/>
      <Route path="/labengine/course/:courseId/lab/:labId/domain/:domainName/buildcanvas" element={<CanvasBuilder/>}/>
      
      <Route path="/labengine/course/:courseId/simulator" element={<ArduinoSimulator/>}/>
      <Route path="/labengine/course/:courseId/notebook" element={<NoteBookSimulator />}/>
      <Route path="/labengine/course/:courseId/node-red-dashboard" element={<NodeRedDashboard />}/>
      
      <Route path="/" element={<BottomTabNav />}>
        <Route path="/profile" element={<Profile />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/knowledgesharing" element={<KnowledgeSharing />} />
        <Route path="/contactAdmin" element={<ContactAdmin />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/cart" element={<ShoppingCart />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />

        <Route path="/student/dashboard" element={<StudentDashboard/>}/>
        <Route path="/student/course/:courseId" element={<StudentCourseManagement/>}/>
        
        <Route path="/instructor/dashboard" element={<InstructorDashboard/>}/>
        <Route path="/instructor/course/:courseId" element={<InstructorCourseManagement />} />
        
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/courses" element={<AdminCourseManagement />} />
        <Route path="/admin/instructors" element={<AdminInstructorManagement />} />
        <Route path="/admin/students" element={<AdminStudentManagement />} />
        <Route path="/admin/messaging" element={<AdminMessaging />} />
        <Route path="/admin/writenote" element={<AdminWriteKnowledge />} />
        <Route path="/admin/configuration" element={<AdminConfigPage />} />
        <Route path="/admin/refunds" element={<AdminRefunds />} />
        
        {/* <Route path="/iot/course/:courseId/circuits" element={<CourseCircuits/>}/> */}

        <Route path="/labengine/course/:courseId/canvases" element={<CourseCanvases/>}/>
      
      </Route>

      {/* Shared/Common Routes */}
      {/* <Route path="/messages" element={<MessageBox />} /> */}

      {/* 404 Not Found - redirect to usergate */}
      <Route path="*" element={<Navigate to="/usergate" replace />} />
    </Routes>
  );
};

export default AppMainNav;